import http from '../../../../../api/http';

const BASE_URL = '/mypage/jobFair';
const API_URL = `${BASE_URL}`;

// 기업정보 조회
function retrieveCorporation(corpId) {
    return http.get(`${API_URL}/retrieveCorporation?corpId=${corpId}`)
}

// 채용공고 리스트 조회(검색)
function retrieveAllCorpPaging(params) {
    return http.post(`${API_URL}/retrieveAllCorpPaging`, params)
}

// 기업정보 등록 (채용공고 등록 전 기업정보 등록 및 정보제공 동의(최초 1회 진행))
function createJobFairCorp(params) {
    return http.post(`${API_URL}/createJobFairCorp`, params)
}

// 기업정보 수정
function updateJobFairCorp(params) {
    return http.post(`${API_URL}/updateJobFairCorp`, params)
}

// 채용공고 리스트 조회(검색)
function retrieveAllJobNoticePaging(params) {
    return http.post(`${API_URL}/retrieveAllJobNoticePaging`, params)
}

// 채용공고 상세 조회
function retrieveJobNotice(jobNoticeSeq) {
    return http.get(`${API_URL}/retrieveJobNotice?jobNoticeSeq=${jobNoticeSeq}`)
}

// 채용공고 등록
function createJobNotice(params) {
    return http.post(`${API_URL}/createJobNotice`, params)
}

// 채용공고 삭제
function deleteJobNotice(params) {
    return http.post(`${API_URL}/deleteJobNotice`, params)
}

// 관심공고 목록 조회
function retrieveInterestJobNoticeListPaging(params) {
    return http.post(`${API_URL}/interestJobNotice/retrieveInterestJobNoticeListPaging`, params)
}

// 관심공고 상태변경
function updateInterestNoticeYn(params) {
    return http.post(`${API_URL}/interestJobNotice/updateInterestNoticeYn`, params)
}

// 채용공고 관심여부
function retrieveInterestJobNoticeYn(jobNoticeSeq) {
    return http.get(`${API_URL}/interestJobNotice/retrieveInterestJobNoticeYn?jobNoticeSeq=${jobNoticeSeq}`)
}

// 관심인재 목록 조회
function retrieveInterestHallEntryListPaging(params) {
    return http.post(`${API_URL}/interestHallEntry/retrieveInterestHallEntryListPaging`, params)
}

// 관심인재 관심여부 변경
function updateCorpInterestHallEntryYn(params) {
    return http.post(`${API_URL}/interestHallEntry/updateCorpInterestHallEntryYn`, params)
}

// 관심기업 관심여부 변경
function updateInterestHallEntryYn(params) {
    return http.post(`${API_URL}/interestHallEntry/updateInterestHallEntryYn`, params)
}

// 관심기업 목록 조회 
function retrieveInterestHallEntryCorpListPaging(params) {
    return http.post(`${API_URL}/interestHallEntry/retrieveInterestHallEntryCorpListPaging`, params)
}

// 관심기업 관심여부
function retrieveInterestHallEntryYn(corpId) {
    return http.get(`${API_URL}/interestHallEntry/retrieveInterestHallEntryYn?corpId=${corpId}`)
}

// 기업 > 관심인재 관심여부 조회
function retrieveCorpInterestHallEntryYn(resumeId) {
    return http.get(`${API_URL}/interestHallEntry/retrieveCorpInterestHallEntryYn?resumeId=${resumeId}`)
}

// 받은 면접제안 목록 조회
function retrieveInterviewProposalEntryListPaging(params) {
    return http.post(`${API_URL}/interviewProposalEntry/retrieveInterviewProposalEntryListPaging`, params)
} 

// 보낸 면접제안 목록 조회
function retrieveCorpInterviewProposalEntryListPaging(params) {
    return http.post(`${API_URL}/interviewProposalEntry/retrieveCorpInterviewProposalEntryListPaging`, params)
}

// 면접제안
function createInterviewProposalEntry(params) {
    return http.post(`${API_URL}/interviewProposalEntry/createInterviewProposalEntry`, params)
}

// 면접제안 상태변경
function updateIntvPropStateGb(params) {
    return http.post(`${API_URL}/interviewProposalEntry/updateIntvPropStateGb`, params)
}

// 학생 > 이력서 등록시 정보제공동의여부
function retrieveRecruitPrivacyAgreeYnByUserId(userId) {
    return http.get(`${API_URL}/retrieveRecruitPrivacyAgreeYnByUserId?userId=${userId}`)
}

// 기업 > 채용공고 등록 시 기업정보 등록 및 정보제공동의여부
function retrieveRecruitPrivacyAgreeYnByCorpId(corpId) {
    return http.get(`${API_URL}/retrieveRecruitPrivacyAgreeYnByCorpId?corpId=${corpId}`)
}

// 기업 > 채용공고 > 입사지원 이력서 목록 엑셀 다운로드
function retrieveApplicantListExcelByJobNoticeSeq(paramObj) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListExcelByJobNoticeSeq`, {
        userId: paramObj.userId, // 0
        jobNoticeSeq: paramObj.jobNoticeSeq, // 0
    }, {
        responseType: 'blob',
    })
}

export default {
    retrieveCorporation,
    retrieveAllCorpPaging,
    createJobFairCorp,
    updateJobFairCorp,
    retrieveInterestJobNoticeListPaging,
    updateInterestNoticeYn,
    retrieveInterestJobNoticeYn,
    retrieveInterestHallEntryListPaging,
    updateCorpInterestHallEntryYn,
    updateInterestHallEntryYn,
    retrieveInterestHallEntryCorpListPaging,
    retrieveInterestHallEntryYn,
    retrieveCorpInterestHallEntryYn,
    retrieveInterviewProposalEntryListPaging,
    retrieveCorpInterviewProposalEntryListPaging,
    createInterviewProposalEntry,
    updateIntvPropStateGb,
    retrieveRecruitPrivacyAgreeYnByUserId,
    retrieveRecruitPrivacyAgreeYnByCorpId,
    retrieveApplicantListExcelByJobNoticeSeq,
};